import { Drawer } from "antd";
import { cloneElement, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AddButton } from "../buttons/AddButton";

export function OnRouteChange(event) {
  // listen to route change events
  const location = useLocation();
  useEffect(() => {
    // close the drawer
    event();
  }, [location]);
}

export const DrawerComponent = ({
  children,
  placement,
  title,
  button,
  width,
  padding,
  bgColor,
  className,
}) => {
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  OnRouteChange(() => {
    if (open) setOpen(false);
  });

  return (
    <>
      <div onClick={showDrawer}>{button}</div>

      <Drawer
        className={className}
        title={title}
        placement={placement}
        onClose={onClose}
        width={width || 500}
        drawerStyle={{ backgroundColor: bgColor }}
        // extra={
        //   <Space>
        //     <Button onClick={onClose}>Cancel</Button>
        //     <Button type="primary" onClick={onClose}>
        //       OK
        //     </Button>
        //   </Space>
        // }
        bodyStyle={{ padding: padding }}
        open={open}
      >
        {children && cloneElement(children, { setOpen: setOpen })}
        {/* {children} */}
      </Drawer>
    </>
  );
};

export const CreateDrawer = ({ form, width, title }) => {
  return (
    <DrawerComponent
      width={width}
      title={title}
      button={<AddButton>{title}</AddButton>}
    >
      {form}
    </DrawerComponent>
  );
};
